import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import InsightDetailPage from "@/pages/InsightDetailPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/insights/:slug" element={<InsightDetailPage />} />
            {/* Legacy paths from previous site versions — redirect to the matching home-page section */}
            <Route path="/about" element={<Navigate to="/#about" replace />} />
            <Route path="/services" element={<Navigate to="/#services" replace />} />
            <Route path="/expertise" element={<Navigate to="/#expertise" replace />} />
            <Route path="/why-vantaris" element={<Navigate to="/#why-vantaris" replace />} />
            <Route path="/insights" element={<Navigate to="/#insights" replace />} />
            <Route path="/contact" element={<Navigate to="/#contact" replace />} />
            {/* Catch-all — any unknown URL goes home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
